const _ = require('lodash');
const { BOOSTER_FLD_PFX } = require('../misc/sharedConstants');

const BoostLabels = {
	cpm: {
		whereIn: {
			__filterFlags: ['renderSuccess'],
		},
		avg: ({ ecpm }) => ecpm,
		algo: 'regression',
	},
	imp: {
		// Should return the "logit" value so that sigmoid(avg(fillRate)) === fillRate
		avg: ({ fillRate }) => {
			const MARGIN = 0.0001;
			const p = Math.max(Math.min(fillRate / 100, 1 - MARGIN), MARGIN);
			return Math.log(p / (1.0 - p));
		},
		algo: 'binary',
	},
};

const BoostTypes = {
	none: {
		labels: [],
	},
	auto: {
		labels: ['cpm', 'imp'],
	},
	floor: {
		labels: ['cpm', 'imp'],
	},
};

const BoostFilters = {
	allRtb: {
		whereIn: { revenueType: ['openRtb'] },
	},
	allHbRtb: {
		whereIn: { revenueType: ['openRtb'], demandChannel: ['headerBidding'] },
	},
};

const Constants = {
	BoostLabels,
	BoostTypes,
	BoostFilters,
	BOOSTER_FLD_PFX,
	AVAIL_BOOST_TYPES: _.keys(BoostTypes),
	AVAIL_BOOST_LABELS: _.keys(BoostLabels),
};

module.exports = Constants;
